import { format, ParsedNumber } from 'libphonenumber-js';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { PhoneFieldsInterface } from '@vendasta/crm';
import {
  validatePhone,
  parsePhoneNumber as parsePhoneGalaxy,
  formatAsRFC3966Phone as formatRFC3966Galaxy,
} from '@vendasta/galaxy/utility/phone-utils';

export const parsePhoneNumber = (phoneValue: string): PhoneFieldsInterface => {
  return parsePhoneGalaxy(phoneValue) as PhoneFieldsInterface;
};

export const formatAsReadonlyPhone = (parsedNumber: PhoneFieldsInterface): string => {
  if (parsedNumber.nationalNumber === '') {
    return '';
  }
  const parsed = {
    country: parsedNumber.isoCountryCode,
    phone: parsedNumber.nationalNumber,
    ext: parsedNumber.extension,
  } as ParsedNumber;

  let internationalNumber = parsedNumber.nationalNumber || '';
  try {
    internationalNumber = format(parsed, 'INTERNATIONAL');
  } catch (e) {
    console.warn('Failed formatting phone number', parsed, e);
  }

  return internationalNumber;
};

export const formatAsRFC3966Phone = (parsedNumber: PhoneFieldsInterface): string => {
  return formatRFC3966Galaxy(parsedNumber as any);
};

export const validatePhoneNumber = (control: AbstractControl): ValidationErrors | null => {
  const parsedPhoneNumber = {
    country: control.value.country,
    phone: control.value.phoneNumber,
    ext: control.value.extension,
  } as ParsedNumber;
  if (!parsedPhoneNumber.phone) {
    return null;
  }
  return validatePhone(parsedPhoneNumber.phone, parsedPhoneNumber.country);
};

export const validateBasedOnPhoneFormGroup = (phoneGroup: FormGroup) => (): ValidationErrors | null => {
  phoneGroup.updateValueAndValidity();
  if (phoneGroup.invalid) {
    return {
      invalidPhoneNumber: true,
    };
  }
  return null;
};
